/** Absolute URL for GTM / analytics when href may be site-relative. */
export const toAbsoluteUrlForTracking = (href: string): string => {
  if (!href) {
    return '';
  }
  if (/^https?:\/\//i.test(href)) {
    return href;
  }
  if (typeof window !== 'undefined') {
    try {
      return new URL(href, window.location.origin).href;
    } catch {
      return href;
    }
  }
  return href;
};
